import React from 'react';
import loadable from '@loadable/component';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const fallbackRefundAndReturnPolicy = `
# An error occurred
The web app couldn\'t reach the backend to fetch the Refund and Return Policy page.

## Possible actions
Please refresh the page and, if that doesn't help, contact the marketplace administrators.
`;

// Create fallback content (array of sections) in page asset format:
export const fallbackSections = {
  sections: [
    {
      sectionType: 'article',
      sectionId: 'refund-and-return-policy',
      appearance: { fieldType: 'customAppearance', backgroundColor: '#ffffff' },
      title: { fieldType: 'heading1', content: 'Refund and Return Policy' },
      blocks: [
        {
          blockType: 'defaultBlock',
          blockId: 'policy-content',
          text: {
            fieldType: 'markdown',
            content: fallbackRefundAndReturnPolicy,
          },
        },
      ],
    },
  ],
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: 'Refund and Return Policy',
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content: 'Our policy for returns and refunds',
    },
  },
};

const FallbackPage = props => {
  return <PageBuilder pageAssetsData={fallbackSections} {...props} />;
};

export default FallbackPage;
